/* eslint-disable @typescript-eslint/no-explicit-any */
import { BlockModel, BlockTypeEnum, toMediaBlockModel, toQuoteBlockModel, toRichTextBlockModel } from './BlockModels'
import SeoComponent, { toSeoComponent } from './SeoComponent'

export enum ValidityEnum {
  Valid = 'valid',
  Expired = 'expired',
}

export enum PositionTypeEnum {
  Open = 'open',
  Specific = 'specific',
}

export default interface CareersPositionVM {
  id: number
  publishedAt: string
  updatedAt: string
  title: string
  slug: string
  alongUuid: string
  location: string
  type: PositionTypeEnum
  validity: ValidityEnum
  description: string
  blocks: BlockModel[]
  seo: SeoComponent | null
}

export const toCareersPositionVM = (response: any): CareersPositionVM | null => {
  const data = response?.data || null
  if (!data) return null

  const res: CareersPositionVM = {
    id: response?.data?.id ?? 0,
    publishedAt: data.publishedAt,
    updatedAt: data.updatedAt,
    title: data.title,
    slug: data.slug,
    alongUuid: data.alongUuid,
    location: data.location,
    type: data.type as PositionTypeEnum,
    validity: data.validity as ValidityEnum,
    description: data.description,
    seo: data.seo ? toSeoComponent(data.seo) : null,
    blocks: [],
  }

  if (data.blocks && data.blocks.length) {
    data.blocks.forEach((block: any) => {
      if (block.__component === BlockTypeEnum.RichText) {
        res.blocks.push(toRichTextBlockModel(block.id, block.body))
      } else if (block.__component === BlockTypeEnum.Media) {
        res.blocks.push(toMediaBlockModel(block.id, block.file))
      } else if (block.__component === BlockTypeEnum.Quote) {
        res.blocks.push(toQuoteBlockModel(block.id, block.title, block.body))
      }
    })
  }

  return res
}
